import { render, staticRenderFns } from "./search-yuer.vue?vue&type=template&id=ec71ed9a&scoped=true&"
import script from "./search-yuer.vue?vue&type=script&lang=ts&"
export * from "./search-yuer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec71ed9a",
  null
  
)

export default component.exports